import { Ionicons } from '@expo/vector-icons';
import { DrawerActions, useNavigation } from 'expo-router/react-navigation';
import React from 'react';
import { Pressable, View } from 'react-native';

import { useIsLargeScreen } from '@/hooks/use-is-large-screen';

export const HomeHeaderButton: React.FC = () => {
	const isLargeScreen = useIsLargeScreen();
	const navigation = useNavigation();

	if (isLargeScreen) return <View style={{ width: 0, height: 0 }} />;

	return (
		<Pressable
			testID="btn-drawer-toggle"
			onPress={() => navigation.dispatch(DrawerActions.toggleDrawer())}
			style={{ padding: 8 }}
		>
			<Ionicons name="menu" size={24} color="#333" />
		</Pressable>
	);
};
